import React from "react";
import "aos/dist/aos.css";

// Remplace ce chemin par l'image de ton choix dans ton dossier assets
import softwareDevImg from "../../assets/SoftwareDevelopment.jpg";

const SoftwareDevelopment = () => {
  return (
    <section
      className="mt-10 w-full py-12 bg-[#F7FDFB]"
      id="software-development"
    >
      <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row items-center gap-10">
        {/* Image */}
        <div
          className="w-full md:w-1/2 flex justify-center"
          data-aos="fade-right"
        >
      
    <img
    src={softwareDevImg}
    alt="Illustration Analyse de Données"
    className="w-full max-w-xl md:max-w-2xl rounded-xl shadow-lg"
    loading="lazy"
    />
        </div>
        {/* Texte principal */}
        <div className="mt-10 w-full md:w-1/2" data-aos="fade-left">
          <h2 className="text-xl md:text-2xl font-bold text-[#00171f] mb-4">
            Développement logiciel sur-mesure
          </h2>
          <p className="text-lg text-gray-700 mb-4">
            <span className="font-semibold text-[#00df9a]">Decintech</span>{" "}
            conçoit et développe des solutions logicielles innovantes, robustes
            et évolutives, parfaitement adaptées à vos besoins métier.
          </p>
          <ul className="space-y-2 text-base text-gray-800 mb-4">
            <li>
              <span className="font-semibold text-[#00df9a]">
                Applications web & mobiles :
              </span>{" "}
              Création d’interfaces modernes, ergonomiques et performantes.
            </li>
            <li>
              <span className="font-semibold text-[#00df9a]">
                APIs & microservices :
              </span>{" "}
              Architecture modulaire pour plus de flexibilité et de scalabilité.
            </li>
            <li>
              <span className="font-semibold text-[#00df9a]">
                Automatisation & DevOps :
              </span>{" "}
              Intégration et déploiement continus pour accélérer la mise en
              production.
            </li>
            <li>
              <span className="font-semibold text-[#00df9a]">
                Qualité & sécurité :
              </span>{" "}
              Tests automatisés, audits de code et respect des meilleures
              pratiques pour garantir la fiabilité de vos logiciels.
            </li>
            <li>
              <span className="font-semibold text-[#00df9a]">
                Maintenance évolutive :
              </span>{" "}
              Suivi, support et évolutions pour accompagner la croissance de vos
              projets.
            </li>
          </ul>
          <p className="text-gray-600">
            Notre équipe vous accompagne de la conception à la mise en
            production, en passant par l’UX/UI, l’architecture, le développement
            et la maintenance.
          </p>
        </div>
      </div>
      {/* Section supplémentaire sous le bloc principal */}
      <div className="max-w-7xl mx-auto mt-4 px-4" data-aos="fade-up">
        <h3 className="text-xl md:text-2xl font-bold text-[#00171f] mb-4">
          Technologies & Méthodologies
        </h3>
        <ul className="list-disc pl-6 text-gray-800 space-y-2 mb-6">
          <li>
            <span className="font-semibold text-[#00df9a]">
              JavaScript, TypeScript, Python, Java :
            </span>{" "}
            Développement backend et frontend.
          </li>
          <li>
            <span className="font-semibold text-[#00df9a]">
              React, Vue, Angular :
            </span>{" "}
            Frameworks modernes pour des interfaces dynamiques et réactives.
          </li>
          <li>
            <span className="font-semibold text-[#00df9a]">
              Node.js, Django, Spring Boot :
            </span>{" "}
            Construction d’APIs performantes et sécurisées.
          </li>
          <li>
            <span className="font-semibold text-[#00df9a]">
              Docker, Kubernetes, CI/CD :
            </span>{" "}
            Conteneurisation, orchestration et automatisation des déploiements.
          </li>
          <li>
            <span className="font-semibold text-[#00df9a]">
              Méthodes Agiles :
            </span>{" "}
            Gestion de projet collaborative et itérative pour plus de
            réactivité.
          </li>
        </ul>
        <p className="text-gray-700">
          Nous mettons l’innovation, la qualité et la sécurité au cœur de chaque
          projet pour garantir votre succès digital.
        </p>
      </div>
    </section>
  );
};

export default SoftwareDevelopment;
